import { render, staticRenderFns } from "./BookshelfCreate.vue?vue&type=template&id=412d5d3b&scoped=true&"
import script from "./BookshelfCreate.vue?vue&type=script&lang=ts&"
export * from "./BookshelfCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d5d3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
